import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import ToolbarOption from '@/checkout-instore-legacy/components/Commons/Elements/ToolbarOption'
import { useMediaQuery } from '@/checkout-instore-legacy/hooks/mediaQuery'

type NoteValue = string | undefined

type Props = {
  noteValue: NoteValue
  onNoteClick: () => void
  label?: string
  isOrderNote?: boolean
}

const extractSalesAssociateCode = (note: NoteValue) => {
  return typeof note === 'string' ? note.split('-')[0] : ''
}

export const ToolbarOptionNote = ({
  noteValue,
  onNoteClick,
  label,
  isOrderNote,
  ...props
}: Props) => {
  const salesAssociateCode = extractSalesAssociateCode(noteValue)
  const isNoteAsVendorCodeEmpty = isOrderNote

  const { value: isDesktop } = useMediaQuery({
    phone: false,
    tablet: false,
    desktop: true,
  })

  const responsiveText = isDesktop ? noteValue : salesAssociateCode

  return (
    <ToolbarOption
      data-testid="note-show"
      icon="fa-attach"
      isEmpty={!isNoteAsVendorCodeEmpty || !noteValue}
      onClick={onNoteClick}
      {...props}
    >
      <Text
        className={csx({
          display: 'block',
          maxWidth: '10rem',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: 'inherit',
        })}
      >
        {responsiveText || label}
      </Text>
    </ToolbarOption>
  )
}
